import './Avatar.css';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import {
  useParticipant,
  useParticipantProperty,
  useMediaTrack,
  useAudioTrack,
} from '@daily-co/daily-react';

import { playAudioAtom } from '../../State';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

//アバター

const AudioStream = React.memo(({ id, isMe }) => {
  const audioTrack = useParticipantProperty(id, 'audioTrack');
  const audioRef = useRef(null); //音声リソース
  const audioState = useAudioTrack(id);

  const [playAudioState, setRecordLocalState] = useRecoilState(playAudioAtom);

  //音声処理
  useEffect(() => {
    //まだDOMが順されていないか、ローカルユーザーの場合はスキップ
    if (!audioTrack || !audioRef.current || isMe) {
      return;
    }
    // audioRef.current.srcObject = new MediaStream([participant?.tracks.audio.persistentTrack]);
    audioRef.current.srcObject = new MediaStream([audioTrack]);

    console.log('音再生してます');
  }, [audioTrack]);

  //音声処理
  useEffect(() => {
    // if (audioState.state == 'blocked') {
    // }
    //var result = window.confirm('play?');
    // if (result) {
    audioRef.current.play();
    // }
  }, [playAudioState]);

  //レンダー処理
  return <audio autoPlay playsInline id={`audio-${id}`} ref={audioRef} />;
});

export default AudioStream;
